import {FC, memo, ReactNode} from 'react';
import {twMerge} from 'tailwind-merge';

import BackButton from '@/components_legacy/onboarding/BackButton';

interface CheckboxProps {
  goBack: () => void;
  title: string;
  description?: string;
  close?: boolean;
  withoutButton?: boolean;
  className?: string;
  icon?: ReactNode;
}

const PageHeader: FC<CheckboxProps> = ({
  goBack,
  title,
  close = false,
  withoutButton = false,
  description,
  className,
  icon,
}: CheckboxProps) => {
  return (
    <div
      className={twMerge(
        'relative z-10 flex min-h-12 items-center gap-6 bg-white px-4 py-2 shadow-md sm:min-h-[68px] sm:py-4',
        className
      )}
    >
      {!withoutButton && (
        <BackButton
          className="absolute"
          close={close}
          arrow={!close}
          onGoBack={goBack}
        />
      )}
      <h2
        className={twMerge(
          'my-auto flex w-full flex-col text-center font-semibold text-2xl max-sm:text-lg',
          description && '-my-4'
        )}
      >
        {title}
        {description && (
          <span className="font-normal text-xs sm:text-base">
            {description}
          </span>
        )}
      </h2>
      {icon && <div className="absolute right-4">{icon}</div>}
    </div>
  );
};

export default memo(PageHeader);
